/**
 * Movepro CRM API interface
 *
 * @package Movepro CRM
 * @module Me
 */

const ROUTE = '/me';

function index() {
    return window.tenantAxios.get(ROUTE);
}

function setActiveTenant(tenantId) {
    return window.centralAxios.patch(ROUTE, {
        tenant_id: tenantId,
    });
}

/**
 * Mint an Intercom Messenger token for the logged-in user. The API is the only
 * source of identity for the Messenger — see useIntercom.
 *
 * `skipRouteAbort` because this fires on login and on tenant switch, both of
 * which navigate immediately — the route-keyed AbortController would otherwise
 * cancel it in flight and the messenger would never boot.
 */
function retrieveIntercomToken(tenantId) {
    return window.centralAxios.get(`${ROUTE}/intercom-token`, {
        params: tenantId ? { tenant_id: tenantId } : {},
        skipRouteAbort: true,
    });
}

// Helper API Services

export default {
    index,
    setActiveTenant,
    retrieveIntercomToken,
};
